import { useCallback, useEffect, useState } from 'react';

import { getRoles } from '../../api/services/Organizers';

type Role = { value: string; label: string };

interface UseRolesHook {
  roleOptions: Role[];
  roleDescriptionMap: Map<string | null, string>;
  roleLabelMap: Map<string, string>;
  isFetching: boolean;
}

export const useRoles = (): UseRolesHook => {
  const [roleOptions, setRoleOptions] = useState<Role[]>([]);
  const [roleDescriptionMap, setRoleDescriptionMap] = useState(new Map());
  const [roleLabelMap, setRoleLabelMap] = useState(new Map());
  const [isFetching, setIsFetching] = useState(false);

  const abortController = new AbortController();

  useEffect(() => {
    fetchRoles();
  }, []);

  useEffect(() => {
    return () => {
      abortController.abort();
    };
  }, []);

  const fetchRoles = useCallback(async () => {
    setIsFetching(true);
    const response = await getRoles(abortController.signal);

    if (abortController.signal.aborted) {
      return;
    }
    if (response?.type === 'success') {
      const rolesOptions = response.data.roles.map(({ description, ...rest }) => rest);
      const map = new Map<string | null, string>([[null, 'Select a Role to view its description']]);
      const roleMap = new Map<string, string>();

      response.data.roles.map((role) => map.set(role.value, role.description));
      response.data.roles.map((role) => roleMap.set(role.value, role.label));

      setRoleOptions(rolesOptions);
      setRoleDescriptionMap(map);
      setRoleLabelMap(roleMap);
    }
    setIsFetching(false);
  }, []);

  return { roleOptions, roleDescriptionMap, roleLabelMap, isFetching };
};
